import { RESET_QUOTES_DATA } from '../../../constants/quoteActionNames';

export default function resetQuotesDataAction() {
  return {
    type: RESET_QUOTES_DATA,
  };
}
